import React, { useContext, memo } from 'react'
import { GatsbyImage, getImage, getSrc, getSrcSet } from 'gatsby-plugin-image'
import { PreloadContext } from '@superrb/gatsby-addons/context'
import { ImageLayout } from '../types/image'

const Image = ({
  image,
  alt,
  className = '',
  layout = ImageLayout.none,
  preload: shouldPreload = false,
  style = {},
  imgStyle = {},
  ...props
}) => {
  const { addPreloadItem } = useContext(PreloadContext)
  const imageData = getImage(image)

  addPreloadItem(
    shouldPreload && imageData
      ? { url: getSrc(image), imagesrcset: getSrcSet(image), as: 'image' }
      : null,
  )

  // Everything rendered after this point is a DOM element,
  // so remove any props which would be invalid in that context
  delete props.fadeIn

  if (!imageData) {
    return <div className={`image-placeholder ${className}`} />
  }

  return (
    <GatsbyImage
      image={imageData}
      alt={alt ?? image?.alt ?? ''}
      className={`image ${className}`}
      loading={shouldPreload ? 'eager' : 'lazy'}
      objectFit={layout === ImageLayout.contain ? 'contain' : 'cover'}
      style={style}
      imgStyle={imgStyle}
      {...props}
    />
  )
}

export default memo(Image)
